import { MenuItem, styled, TextField } from "@mui/material";

const StyledTextField = styled(TextField)(() => ({
  "& .MuiInputBase-root": {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
}));

const options = [7, 14, 30, 60, 90, 120];

interface IDatePickerSelectorProps {
  setDate: (value: string) => void;
  value: string;
  label: string;
  size?: "small" | "medium";
  custom?: string | null;
}
function DatePickerSelector({
  setDate,
  label,
  size,
  value,
  custom,
}: IDatePickerSelectorProps) {
  return (
    <StyledTextField
      fullWidth
      select
      label={label}
      value={value}
      size={size}
      onChange={(e) => setDate(e.target.value)}
    >
      {options.map((o) => (
        <MenuItem key={o} value={o}>
          Last {o} Days
        </MenuItem>
      ))}
      {custom && <MenuItem value="custom">{custom}</MenuItem>}
    </StyledTextField>
  );
}

export default DatePickerSelector;
